import React, { Component } from "react";
import { Query } from "react-apollo";
import { MyContext } from "../../../../../context";
import RIAccordion from "../../../../ConversationSafe/Accordion/RIAccordion";
import Incident from "./Incident";
import { Dialog, DialogType, DialogFooter } from "office-ui-fabric-react/lib/Dialog";
import { getConversationCases, getAllFoldersShrinked, saveConversationInCaseManagement } from "../../../../ConversationSafe/ConversationSafeQuery";
import { Spinner, Text, Stack, DefaultButton, Dropdown, SpinnerSize, MessageBar, MessageBarType, PrimaryButton } from "office-ui-fabric-react";
import AlertBar from "../../../../CustomComponents/AlertBar";

export default class CaseManagement extends Component {
    static contextType = MyContext;
    constructor(props) {
        super(props);
        this.state = {
            foldersLoaded: false,
            casesLoaded: false,
            allFoldersData: null,
            foldersData: null,
            casesData: null,
            hasError: false,
            savedCaseFolders: [],
            selectedCaseFolders: [],
            mutationLoading: false,
            alertMessagePanel: "",
            isChanged: false,
            isOpen: false,
            pendingRemoveOption: null
        };
    }

    getAvailableFolders = (allFolders, savedCaseFolders = this.state.savedCaseFolders) => {
        let disabledFolder = this.getFolderToDisabled(allFolders, savedCaseFolders);
        return allFolders.map((folder) => {
            return {
                key: folder.id,
                text: folder.name,
                disabled: disabledFolder.includes(folder.id),
            };
        });
    };

    getFolderToDisabled = (allFolders, savedCaseFolders = this.state.savedCaseFolders) => {
        let disabledFolder = [];
        let ruleAccess = this.props.userRules?.ruleAccess;

        if (ruleAccess?.userSafe === "Restricted") {
            let ownAdd = ruleAccess?.ownFolder?.addConversations;
            let ownRemove = ruleAccess?.ownFolder?.removeConversations;

            for (let i = 0; i < allFolders.length; i++) {
                let folder = allFolders[i];
                let folderSelected = savedCaseFolders.includes(folder.id);

                if (folder.userId == this.props.userRules?.userId) {
                    if (folderSelected && !ownRemove) {
                        disabledFolder.push(folder.id);
                    }
                    if (!folderSelected && !ownAdd) {
                        disabledFolder.push(folder.id);
                    }
                } else {
                    if (folderSelected && !folder.removeConversations) {
                        disabledFolder.push(folder.id);
                    }
                    if (!folderSelected && !folder.addConversations) {
                        disabledFolder.push(folder.id);
                    }
                }
            }
        }

        return disabledFolder;
    };

    clearAlert = () => {
        if (this.state.alertMessagePanel !== "") {
            this.setState({
                alertMessagePanel: "",
            });
        }
    };

    close = () => this.setState({ isOpen: false });

    handleIncidentDataUpdated = () => {
        this.setState({
            casesLoaded: false,
        });
    };

    checkLastCaseUnchecked = () => {
        if (this.state.selectedCaseFolders.length === 0) {
            this.setState({ isOpen: true });
        }
        else {
            this.save();
        }

    }

    save = () => {
        this.setState({
            mutationLoading: true,
            isOpen: false,
        });
        this.props.isProcessing(true);
        this.props.client
            .mutate({
                mutation: saveConversationInCaseManagement,
                variables: {
                    input: this.props.authorization,
                    conversationId: this.props.conversationId,
                    folders: this.state.selectedCaseFolders,
                },
                awaitRefetchQueries: true,
                refetchQueries: [
                    {
                        query: getAllFoldersShrinked,
                        variables: { input: this.props.authorization, filter: "CaseManagement" },
                    },
                    {
                        query: getConversationCases,
                        variables: { conversationId: this.props.conversationId },
                    },
                ],
            })
            .then((res) => {
                this.props.isProcessing(false);
                if (res.data.saveCasesInConversation.status === "ok") {
                    this.setState({
                        mutationLoading: false,
                        foldersLoaded: false,
                        casesLoaded: false,
                        isChanged: false,
                    });
                } else {
                    this.setState({
                        alertMessagePanel: this.context.getTranslation("detailContainer", "saveErrorCaseManagement"),
                        mutationLoading: false,
                        casesLoaded: false,
                    });
                }
                this.props.refreshFolderList(true)
            })
            .catch((err) => {
                this.props.isProcessing(false);
                this.setState({
                    mutationLoading: false,
                });
            });
    };

    render() {
        const { foldersLoaded, casesLoaded, foldersData, casesData, hasError, selectedCaseFolders } = this.state;
        const bothLoaded = foldersLoaded && casesLoaded;

        return (
            <div>
                <Dialog
                    isOpen={this.state.isOpen}
                    type={DialogType.close}
                    onDismiss={this.close.bind(this)}
                    title={this.context.getTranslation("compliance", "riskRatingAdherence")}
                    subText={this.context.getTranslation("conversationSafe", "teachingBubbleTextLastFolder")}
                    isBlocking={false}
                    closeButtonAriaLabel="Close"
                    items={this.state.items}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={this.save} text={this.context.getTranslation("common", "remove")} />
                        <DefaultButton onClick={this.close} text={this.context.getTranslation("common", "cancel")} />
                    </DialogFooter>
                </Dialog>
                <Query query={getAllFoldersShrinked} variables={{ input: this.props.authorization, filter: "CaseManagement" }}>
                    {({ loading, error, data }) => {
                        if (!loading && !this.state.foldersLoaded) {
                            if (error) {
                                console.log(error);
                                this.setState({ hasError: true, foldersLoaded: true });
                            } else {
                                const allFoldersData = data.getConversationSafeFolders;
                                this.setState((prevState) => ({
                                    allFoldersData,
                                    foldersData: this.getAvailableFolders(allFoldersData, prevState.selectedCaseFolders || []),
                                    foldersLoaded: true,
                                }));
                            }
                        }
                        return null;
                    }}
                </Query>

                <Query query={getConversationCases} variables={{ conversationId: this.props.conversationId }}>
                    {({ loading, error, data, refetch }) => {
                        if (!loading && !this.state.casesLoaded) {
                            if (error || data.getConversationCases == null) {
                                this.setState({ hasError: true, casesLoaded: true });
                            } else {
                                const conversationCases = data.getConversationCases;
                                const selectedCaseFolders = conversationCases.map((incident) => incident.convIncident.caseId);
                                this.setState((prevState) => ({
                                    casesData: {
                                        ...data,
                                        getConversationCases: conversationCases,
                                    },
                                    casesLoaded: true,
                                    savedCaseFolders: selectedCaseFolders,
                                    selectedCaseFolders,
                                    foldersData: this.getAvailableFolders(prevState.allFoldersData || [], selectedCaseFolders),
                                    isChanged: false,
                                }));
                            }
                        }
                        return null;
                    }}
                </Query>

                {!bothLoaded && <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />}

                {hasError && <AlertBar message={"Error!"} alertType={"error"} />}

                {bothLoaded && !hasError && (
                    <>
                        {this.state.alertMessagePanel !== "" && (
                            <MessageBar messageBarType={MessageBarType.error} isMultiline={false} dismissButtonAriaLabel="Close" onDismiss={this.clearAlert}>
                                {this.state.alertMessagePanel}
                            </MessageBar>
                        )}
                        <Stack horizontal verticalAlign="end" style={{ padding: "0px 0px 20px 20px" }}>
                            <Stack.Item align="center" style={{ maxWidth: "600px", minWidth: "200px", marginRight: "20px" }}>
                                <Dropdown
                                    style={{ width: "250px" }}
                                    placeholder={this.context.getTranslation("detailContainer", "addRemovePlaceholder")}
                                    label={this.context.getTranslation("detailContainer", "addRemove")}
                                    multiSelect
                                    onChange={(_, option) => {
                                        if (option) {
                                            let updatedSelection;
                                            if (option.selected) {
                                                updatedSelection = [...selectedCaseFolders, option.key];
                                            } else {
                                                updatedSelection = selectedCaseFolders.filter((key) => key !== option.key);
                                            }
                                            this.setState({ selectedCaseFolders: updatedSelection, isChanged: true });
                                        }

                                    }}
                                    selectedKeys={selectedCaseFolders}
                                    options={foldersData}
                                />
                            </Stack.Item>
                            <Stack.Item>
                                <DefaultButton
                                    text={
                                        this.state.mutationLoading ? (
                                            <Spinner style={{ paddingLeft: "5px", position: "relative", top: "2px" }} size={SpinnerSize.xSmall} />
                                        ) : (
                                            this.context.getTranslation("common", "save")
                                        )
                                    }
                                    onClick={this.checkLastCaseUnchecked}
                                    disabled={!this.state.isChanged || this.state.mutationLoading}
                                />
                            </Stack.Item>
                        </Stack>

                        <RIAccordion
                            theme={this.props.theme}
                            data={casesData.getConversationCases.map((incident, i) => {
                                return {
                                    header: <Text>{incident.convIncident.caseName}</Text>,
                                    content: (
                                        <Incident
                                            status={incident.convIncident.status}
                                            riskRating={incident.convIncident.riskRating}
                                            incidentThreadId={incident.convIncident.incidentThreadId}
                                            forwardTo={incident.convIncident.forwardTo}
                                            reviewers={incident.caseDetails.reviewers}
                                            observers={incident.caseDetails.observers}
                                            caseStatus={incident.caseDetails.caseStatus}
                                            caseId={incident.convIncident.caseId}
                                            client={this.props.client}
                                            authorization={this.props.authorization}
                                            height={this.props.height}
                                            userRules={this.props.userRules}
                                            conversationId={this.props.conversationId}
                                            isProcessing={this.props.isProcessing}
                                            onDataUpdated={this.handleIncidentDataUpdated}
                                            refreshFolderList={this.props.refreshFolderList}
                                        />
                                    ),
                                };
                            })}
                        />
                    </>
                )}
            </div>
        );
    }
}
